module.exports = __webpack_public_path__ + "static/media/philosophical.82a45cf9.png";